import { useEffect, useState } from 'react';
import Navbar from '../HomeComponents/Navbar';
import { Link } from 'react-router-dom';
import auth from '../../api/auth';
import { toast } from 'react-hot-toast';
import { HiOutlineHashtag } from 'react-icons/hi';

function Meter({ nextStep, meterNumber, setMeterNumber }) {
  const [error, setError] = useState(false);
  const [validating, setValidating] = useState(false);

  const handleClick = async (e) => {
    e.preventDefault();

    if (meterNumber === '' || meterNumber?.trim()?.length === 0) {
      setError(true);
      return;
    }

    setValidating(true);
    try {
      if (error) setError(false);
      const { data } = await auth.validateMeter({ meter_number: meterNumber });
      setValidating(false);
      if (!data.data.status) {
        toast.error(data.data.message);
      } else {
        sessionStorage.setItem(
          'meter_hierarchy',
          JSON.stringify(data.data.hierarchy || []),
        );
        nextStep();
      }
    } catch (e) {
      console.error(e);
      setError(true);
      setValidating(false);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleClick(e);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  });

  return (
    <div >
      <Navbar />

      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-lg">

          {/* Page header */}
          <div className="mb-8 text-center">
            <p className="text-xs font-semibold tracking-widest text-pw-blue uppercase mb-1">
              Start for free
            </p>
            <h1 className="text-3xl font-bold text-gray-900">
              Create your account
            </h1>
            <p className="text-sm text-gray-400 mt-2">
              Enter your meter number to get started
            </p>
          </div>

          {/* Card */}
          <div className="bg-white rounded-2xl shadow-lg shadow-gray-200/60 border border-gray-100 p-8">

            {/* Input label */}
            <label
              htmlFor="meterNumber"
              className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 pl-1">
              Meter Number
            </label>

            {/* Input wrapper */}
            <div
              className={`flex items-center gap-3 border-2 rounded-xl px-4 py-3 transition-all duration-200 focus-within:shadow-md ${
                error
                  ? 'border-red-400 focus-within:border-red-400 focus-within:shadow-red-100'
                  : 'border-gray-200 hover:border-gray-300 focus-within:border-[#109CF1] focus-within:shadow-[#109CF1]/10'
              }`}>
              <HiOutlineHashtag
                size={20}
                className={error ? 'text-red-400 shrink-0' : 'text-gray-400 shrink-0'}
              />
              <input
                id="meterNumber"
                name="meterNumber"
                type="text"
                required
                value={meterNumber}
                onChange={(e) => {
                  setMeterNumber(e.target.value);
                  if (error) setError(false);
                }}
                placeholder="e.g. 04150123456"
                autoComplete="off"
                className="flex-1 bg-transparent border-none outline-none text-sm text-gray-800 placeholder-gray-400 min-h-[28px]"
              />
            </div>

            {/* Inline error */}
            {error && (
              <p className="text-xs text-red-500 mt-1.5 pl-1">
                Invalid meter number — please check and try again.
              </p>
            )}

            {/* Submit button */}
            <button
              type="button"
              id="continue-btn"
              onClick={handleClick}
              disabled={validating}
              className="mt-6 w-full py-3.5 bg-pw-blue hover:bg-[#0d8fd9] active:scale-95 disabled:opacity-60 disabled:cursor-not-allowed text-white font-semibold text-sm rounded-3xl transition-all duration-200 shadow-md shadow-[#109CF1]/30 flex items-center justify-center gap-2">
              {validating ? (
                <>
                  <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  Validating…
                </>
              ) : (
                'Continue →'
              )}
            </button>

            {/* Login link */}
            <p className="text-center text-sm text-gray-500 mt-6">
              Already have an account?{' '}
              <Link
                to="/login"
                className="text-pw-blue font-semibold hover:underline">
                Log in
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Meter;
